<template>
  <div>
    <div class="title-lable-error">
      <span class="ml-3">No machines available</span>
    </div>
    <div
      class="d-flex flex-row align-items-center mt-3 ml-3"
      style="color: #757575; font-size: 0.85rem"
    >
      <p>
        One of the packages you choose is currently not available. Please choose
        another machine or try again at a different time.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {},
};
</script>